import { Currency } from 'dinero.js';
import { moneyInterface } from './types';

export enum ChargeCategory {
    Adjustment = 'Adjustment',
    InboundShipment = 'InboundShipment',
    InventoryAdjustment = 'InventoryAdjustment',
    OutboundShipment = 'OutboundShipment',
    Service = 'Service',
    Storage = 'Storage',
    ItemStorage = 'ItemStorage',
    ProductionBatch = 'ProductionBatch',
}

export enum ChargeStatus {
    Open = 'Open',
    Invoiced = 'Invoiced',
    Voided = 'Voided',
}

export enum InvoiceStatus {
    Draft = 'Draft',
    Finalized = 'Finalized',
    Voided = 'Voided',
    Paid = 'Paid',
}

interface chargerChargeeFields {
    charger_type: 'platform' | 'company'
    charger_id: string | number
    chargee_type: 'service-provider-billing-account' | 'team'
    chargee_id: string | number
}

export interface chargeInterface extends moneyInterface, chargerChargeeFields {
    id: number
    created_at: string
    category: string
    description: string
    is_void?: boolean
    is_invoiced?: boolean
    invoice_id: number | null
    stripe_invoice_item_id: string | null
    status: ChargeStatus
}

export interface chargeItemInterface {
    id: number
    charge_id: number
    parent_id: number | null
    chargeable_item_type: string | null
    chargeable_item_id: string | null
    chargeable_item: { id: number; description: string } | null
    should_show_units?: string
    is_amendment: boolean
    description: string | null
    units: number
    unit_price_amount: number
    line_price_amount: number
}

export interface chargeableItemInterface {
    id: number | string
    description: string
}

export interface chargeItemTreeInterface extends chargeItemInterface {
    items: chargeItemTreeInterface[]
}

export interface storeQuickAdjustmentFormInterface {
    amount: number
    description: string
}

export interface storeClientServiceChargeFormInterface {
    company_service_id: number
    quantity: number
    description: string
}

export interface invoiceStripeAutomaticTaxOptions {
    enabled: boolean | null,
}

export interface invoiceInterface extends chargerChargeeFields {
    id: number
    total: number
    status: InvoiceStatus
    currency: Currency
    stripe_invoice_id: string | null
    stripe_invoice_status: string | null
    created_at: string
    voided_at?: string
    finalized_at?: string
    is_creating_on_stripe?: boolean
    charges?: chargeInterface[]
    stripe_automatic_tax: invoiceStripeAutomaticTaxOptions
}

export interface merchantReceivablesInterface {
    merchant_id: number
    open_charges_count: number
    open_charges_amount: number
    draft_invoices_count: number
    draft_invoices_amount: number
    unpaid_invoices_count: number
    unpaid_invoices_amount: number
    currency: Currency
}
